module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/testimonials.json
// module id = 1508
// module chunks = 275063409773762